module.exports = __webpack_public_path__ + "static/media/language-country-menu.ed0f7764.jpg";